import './Offcanvas.scss';

import { b2x } from '@b2x/react/src';
import classnames from 'classnames';

import { Button } from './Button';
import { t } from './i18n/i18n';

export type OffcanvasHeaderProps = b2x.OffcanvasHeaderProps;

export const OffcanvasHeader = (props: OffcanvasHeaderProps) => (
  <b2x.OffcanvasHeader customComponent={CustomOffcanvasHeader} {...props} />
);

const CustomOffcanvasHeader = ({ children, className, smallPadding, title }: b2x.OffcanvasHeaderProps) => {
  const { id } = b2x.useModalContext();
  return (
    <div className={classnames('offcanvas-header-wrapper py-3 pb-0', smallPadding ? 'px-3' : 'px-5')}>
      <div className={classnames('offcanvas-header p-0 pb-3 border-bottom border-gray-200', className)}>
        {(title || children) && (
          <h4 className="offcanvas-title text-blue" id={`${id}-label`}>
            {title}
            {children}
          </h4>
        )}
        <Button
          aria-label={t('accessibility.button.close')}
          data-bs-dismiss="offcanvas"
          iconEnd={{ name: 'delete' }}
          type="button"
          variant="blank"
        />
      </div>
    </div>
  );
};
